import { useGuidedSearchContext } from './GuidedSearchContext';
import type { ITripDistanceInfo } from './types';

export const useGuidedSearchTripDistanceInfo = () => {
  const { tripDistanceInfo, updateTripDistanceInfo } = useGuidedSearchContext();

  const handleTripDistanceChange = (newTripDistanceInfo: ITripDistanceInfo) => {
    updateTripDistanceInfo(newTripDistanceInfo);
  };

  const isTripDistanceValid = true;

  return { tripDistanceInfo, handleTripDistanceChange, isTripDistanceValid };
};
